<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            
            <!-- Filtros de Dealers -->
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{'relatorioVeiculos.veiculoRegional.dealers'}}
                </div>
                <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                  {{dealer.nome}}
                  <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                </span>
                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <hr>

            <!-- Controles de Data e Filtros -->
            <div class="row ptb20">
              <div class="col col-3">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'relatorioVeiculos.veiculoRegional.dataInicial'}}
                </div>
                <p-calendar [(ngModel)]="dataInicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true"
                  (onClearClick)="limpaDataInicial()" [monthNavigator]="true" yearRange="2000:2030"
                  placeholder="{{'relatorioVeiculos.veiculoRegional.dataInicialPlaceHolder' | translate}}"
                  showButtonBar="true" (onSelect)="onDataInicialChange()">
                </p-calendar>
              </div>
              <div class="col col-3">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'relatorioVeiculos.veiculoRegional.dataFinal'}}
                </div>
                <p-calendar [(ngModel)]="dataFinal" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" (onClearClick)="limpaDataFinal()"
                  placeholder="{{'relatorioVeiculos.veiculoRegional.dataFinalPlaceHolder' | translate}}"
                  showButtonBar="true" [monthNavigator]="false" [yearNavigator]="false" yearRange="2000:2030"
                  [minDate]="getMinDateFinal()" [maxDate]="getMaxDateFinal()" (onSelect)="onDataFinalChange()">
                </p-calendar>
              </div>
              <div class="col col-lg-6 col-md-12 mt-3">
                <div class="d-flex align-items-end justify-content-between flex-wrap">
                  <div class="d-flex flex-wrap">
                    <button translate type="button" class="btn btn-primary mr-2 mb-2" (click)="filtroAPI()">
                      {{'relatorioVeiculos.veiculoRegional.filtrar' | translate}}
                      <i class="fas fa-search ml-1"></i>
                    </button>
                    <button [class.btn-info]="!getListagemComFiltros()" [class.btn-warning]="getListagemComFiltros()"
                        translate class="btn mr-2 mb-2" type="button" (click)="exibirFiltro()">
                      {{'relatorioVeiculos.veiculoRegional.maisFiltros' | translate}}
                      <em class="fa fa-filter ml-1"></em>
                    </button>
                  </div>
                  <div class="d-flex">
                    <button pButton class="p-button-outlined p-button-secondary p-button-sm mb-2" type="button"
                      (click)="exportExcel()">
                      <i class="fa fa-download mr-1"></i>Export Excel
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Aviso de mudança de data -->
            <div class="row" *ngIf="mostrarAvisoMudancaData">
              <div class="col col-12">
                <div class="alert alert-info alert-md d-flex flex-wrap align-items-start mb-0" role="alert">
                  <div class="d-flex align-items-start aviso-texto-container">
                    <i class="fa fa-info-circle fa-lg mr-3 flex-shrink-0 mt-1"></i>
                    <span class="h6 mb-0">
                      <strong>{{ 'relatorioVeiculos.veiculoRegional.avisoMudancaData.dadosDesatualizados' | translate }}</strong> {{ 'relatorioVeiculos.veiculoRegional.avisoMudancaData.mensagem' | translate }}
                    </span>
                  </div>
                  <div class="d-flex align-items-center justify-content-end aviso-botoes-container">
                    <button type="button" class="btn btn-primary mr-2" (click)="aplicarFiltroData()">
                      <i class="fa fa-refresh"></i> {{ 'relatorioVeiculos.veiculoRegional.avisoMudancaData.aplicarFiltro' | translate }}
                    </button>
                    <button type="button" class="btn btn-outline-danger" (click)="ignorarAvisoData()">
                      <i class="fa fa-times"></i> {{ 'relatorioVeiculos.veiculoRegional.avisoMudancaData.ignorar' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Botões para alternar tipo de relatório -->
            <div class="row">
              <div class="col col-lg-8 col-md-12">
                <div class="d-flex flex-wrap">
                  <button pButton type="button"
                    (click)="alterarTipoRelatorio('regional')" 
                    [class.p-button-primary]="tipoRelatorio === 'regional'"
                    [class.p-button-outlined]="tipoRelatorio !== 'regional'"
                    class="p-button-sm p-button-secondary mr-2 mb-2">
                    {{ 'relatorioVeiculos.veiculoRegional.relatorioRegional' | translate }}
                  </button>
                  <button pButton type="button"
                    (click)="alterarTipoRelatorio('faturamentoDiario')"
                    [class.p-button-primary]="tipoRelatorio === 'faturamentoDiario'"
                    [class.p-button-outlined]="tipoRelatorio !== 'faturamentoDiario'"
                    class="p-button-sm p-button-secondary mb-2">
                    {{ 'relatorioVeiculos.veiculoRegional.faturamentoDiario' | translate }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Mensagem de validação de datas -->
            <div class="row mb-3" *ngIf="dataInicial && dataFinal && !validarDataFinal()">
              <div class="col col-12">
                <div class="alert alert-warning alert-sm" role="alert">
                  <i class="fa fa-exclamation-triangle"></i>
                  <strong>Atenção:</strong> A data final deve estar entre {{ dataInicial | date:'dd/MM/yyyy' }} e {{ getMaxDateFinal() | date:'dd/MM/yyyy' }} (último dia do mês da data inicial).
                </div>
              </div>
            </div>
            
            <hr>
            
            <!-- Componentes condicionais - apenas grids -->
            <div class="row">
              <div class="col col-12">
                <!-- Regional Component -->
                <app-regional *ngIf="isRelatorioRegional" 
                             [dadosGrid]="dadosGrid" 
                             [loading]="loading"
                             [tipoRelatorio]="tipoRelatorio">
                </app-regional>
                
                <!-- Faturamento Diário Component -->
                <app-faturamento-diario *ngIf="isFaturamentoDiario" 
                                       [dadosGrid]="dadosGrid" 
                                       [loading]="loading"
                                       [tipoRelatorio]="tipoRelatorio"
                                       [dataInicial]="dataInicialAplicada"
                                       [dataFinal]="dataFinalAplicada">
                </app-faturamento-diario>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Dialog de Filtros -->
<p-dialog header="Definir filtros" [(visible)]="displayFiltros" [style]="{width: '550px'}" [modal]="true"
  [draggable]="false">
  <form [formGroup]="form">
    <div class="container striped-rows">
      <div class="row mb-3">
        <div translate class="col col-4">
          {{'relatorioVeiculos.veiculoRegional.filtros.regional' | translate}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.veiculoRegional.filtros.regionalPlaceHolder' | translate}}"
            [options]="regiao" optionLabel="nome" optionValue="valor" formControlName="regiao"
            [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
    <button translate type="button" class="btn btn-info"
      (click)="filtroAPI()">{{'relatorioVeiculos.veiculoRegional.filtrar'}}</button>
  </ng-template>
</p-dialog>

<!-- <p-dialog header="{{'relatorioVeiculos.veiculoRegional.selecioneDealers' | translate}}"
  [(visible)]="displayFiltrosDealers" [style]="{width: '800px'}" [modal]="true" [draggable]="false">
  <div class="d-flex flex-wrap">
    <ng-container *ngFor="let item of filtrosDealers.naoSelecionados()">
      <span class="btn btn-primary btn-sm itemListaSelecao" style="font-size: 14px; margin: 2px;"
        (click)="onAdicionarDealerFiltro(item)">
        {{item.toTexto()}}
      </span>
    </ng-container>
  </div>
</p-dialog> -->

<!-- Componente modular para filtro de dealers -->
<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'relatorioVeiculos.controleProposta.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.controlePedidos.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>

<p-toast key="rmpvDetalhado" position="bottom-right"></p-toast>